import {HcSubscription} from "./health-check/hc-subscription.model";

export class CareSeekerSimpleModel {
  _id: string;
  Email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  country?: string;
  stateProvince?: string;
  stripe_account: string;
  partnerId?: string;
  /** Set server-side when the profile is first stored; legacy rows are backfilled from Firebase Auth user creation time when possible, else `lastUpdated`. */
  createdAt?: Date;
  lastUpdated: Date = new Date();
  disabled = false;
  deleted = false;
  devices: string[] = [];
  hcSubscription?: HcSubscription; // Embedded subscription document
  /** When true, the care seeker has already paid the one-time setup fee; do not display or charge it again. */
  setupFeePaid?: boolean;
}
